<template>
    <div class="content">
        <el-table :data="tableData" border style="width: 100%" height="100%">
            <el-table-column prop="groupName" label="监控内容" width="130">
            </el-table-column>
            <el-table-column prop="status" label="在线状态" width="70">
                <template slot-scope="scope">
                    <span v-if="scope.row.status == 1" style="color: #67c23a;">设备在线</span>
                    <span v-else style="color: #f56c6c;">设备离线</span>
                </template>
            </el-table-column>
            <el-table-column prop="ua" label="相电压(V)" width="120">
                <template slot-scope="scope">
                    {{ scope.row.ua }}, {{ scope.row.ub }}, {{ scope.row.uc }}
                </template>
            </el-table-column>
            <el-table-column prop="ia" label="相电流(A)" width="120">
                <template slot-scope="scope">
                    {{ scope.row.ia }}, {{ scope.row.ib }}, {{ scope.row.ic }}
                </template>
            </el-table-column>
            <el-table-column prop="cos" label="功率因数(%)" width="92">
            </el-table-column>
            <el-table-column prop="pf" label="瞬时总功率(KW)" width="114">
            </el-table-column>
            <el-table-column prop="kwh" label="正向总功率(KWH)" width="124">
            </el-table-column>
            <el-table-column prop="terminalTime" label="最后更新时间" width="160">
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props: [ 'dataInfo' ],
    data() {
        return {
            title: '料仓环境监测',
            status: '设备在线',
            tableData: []
        };
    },
    watch: {
        dataInfo: {
            handler(val) {
                this.tableData = val
                if(val.length) {
                    this.tableData.forEach(item => {
                        if(item._groupName) {
                            item.groupName = item._groupName
                            item.status = item.Status
                            item.ua = item.Ua
                            item.ub = item.Ub
                            item.uc = item.Uc
                            item.ia = item.Ia
                            item.ib = item.Ib
                            item.ic = item.Ic
                            item.cos = item.Cos
                            item.pf = item.PF
                            item.kwh = item.KWH
                            item.terminalTime = item._terminalTime
                        }
                    })
                }
            },
            deep: true
        }
    },
    mounted() {
        this.tableData = this.dataInfo
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    height: 100%;
    border: 1px solid #ccc;
}
::v-deep .el-table--small .el-table__cell {
    padding: 2px 0 !important;
}
::v-deep .el-table tr {
    min-height: 28px !important;
    height: 16.66% !important;
}
::v-deep .el-table__body, .el-table__footer, .el-table__header {
    height: 100% !important;
}
</style>